//#region ../uuid/dist/uuidv7.js
var seedCounter = (high, low) => (high & 511) * 2 ** 32 + low;
function createUuidv7({ now = () => Date.now(), random = (words) => crypto.getRandomValues(words) } = {}) {
	let timestamp = -1;
	let counter = 0;
	return () => {
		const [high, low, tail] = random(/* @__PURE__ */ new Uint32Array(3));
		const current = now();
		if (current > timestamp) {
			timestamp = current;
			counter = seedCounter(high, low);
		} else counter++;
		const bytes = /* @__PURE__ */ new Uint8Array(16);
		const view = new DataView(bytes.buffer);
		view.setUint16(0, Math.floor(timestamp / 2 ** 32));
		view.setUint32(2, timestamp % 2 ** 32);
		view.setUint16(6, 28672 + Math.floor(counter / 2 ** 30));
		view.setUint32(8, 2147483648 + counter % 2 ** 30);
		view.setUint32(12, tail);
		return bytes;
	};
}
var uuidv7 = createUuidv7();
//#endregion
export { createUuidv7, uuidv7 };
